<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <form [formGroup]="formGroup">
        <div class="grid col7">
        <h3 class="break">{{ t("employementRelation.title") }}</h3>
      <kendo-formfield>
        <kendo-label>{{ t("validFrom") }}</kendo-label>
        <kendo-datepicker formControlName="validFrom"></kendo-datepicker>
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label>{{ t("validTo") }}</kendo-label>
        <kendo-datepicker formControlName="validTo"></kendo-datepicker>
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

        <kendo-formfield>
            <kendo-label>{{ t("workload") }}</kendo-label>
                <kendo-numerictextbox
                [style.width.px]="170"
                [step]="5"
                [min]="0"
                [max]="100"
                [autoCorrect]="true"
                formControlName="workload"
            >
            </kendo-numerictextbox>
            <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
        </kendo-formfield>

      <kendo-formfield>
        <kendo-label>{{ t("hasFlexTime") }}</kendo-label>
        <input type="checkbox" formControlName="hasFlexTime" kendoCheckBox />
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      <h3 class="break">{{ t("vacationDays.title") }}</h3>
      <kendo-formfield>
          <kendo-label>
            {{ t("vacationDaysFulltime") }}
            <app-info-button>
              <p>{{t('vacationDays.tooltip')}}</p>
            </app-info-button>
          </kendo-label>
              <kendo-numerictextbox
              [style.width.px]="170"
              [step]="0.5"
              [min]="0"
              formControlName="vacationDays"
          >
          </kendo-numerictextbox>
          <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="isFirstWorkTime">
          <kendo-label>
            {{ t("initialVacationDays") }}
            <app-info-button>
              <p>{{t('initialVacationDays.tooltip')}}</p>
            </app-info-button>
        </kendo-label>
              <kendo-numerictextbox
              [style.width.px]="170"
              [step]="0.5"
              [min]="0"
              formControlName="initialVacationDays"
          >
          </kendo-numerictextbox>
      </kendo-formfield>

      <h3 class="break">
        {{t('hourlyRates.title')}}
        <app-info-button>
          <p>{{t('hourlyRates.description')}}</p>
        </app-info-button>
      </h3>
      <kendo-formfield>
        <kendo-label>{{ t("hourlyRateInternal") }}</kendo-label>
            <kendo-numerictextbox
            [style.width.px]="170"
            [min]="0"
            formControlName="hourlyRateInternal"
            >
        </kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield>
        <kendo-label>{{ t("hourlyRateExternal") }}</kendo-label>
            <kendo-numerictextbox
            [style.width.px]="170"
            [min]="0"
            formControlName="hourlyRateExternal"
            >
        </kendo-numerictextbox>
    </kendo-formfield>

      <!-- Start Monday -->
    </div>
    <div class="grid col7">
      <h3 class="break ptm">{{t('workTime.title')}}</h3>
      <h4>{{t('monday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("mondayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="mondayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('mondayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("mondayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="mondayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('mondayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("mondayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="mondayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('mondayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("mondayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="mondayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('mondayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountMonday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountMonday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountMonday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeMonday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeMonday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeMonday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Monday -->

      <!-- Start Tuesday -->
      <h4>{{t('thuesday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("tuesdayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="tuesdayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('tuesdayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("tuesdayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="tuesdayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('tuesdayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("tuesdayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="tuesdayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('tuesdayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("tuesdayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="tuesdayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('tuesdayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountTuesday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountTuesday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountTuesday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeTuesday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeTuesday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeTuesday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Tuesday -->

      <!-- Start Wednesday -->
      <h4>{{t('wednesday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("wednesdayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="wednesdayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('wednesdayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("wednesdayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="wednesdayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('wednesdayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("wednesdayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="wednesdayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('wednesdayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("wednesdayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="wednesdayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('wednesdayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountWednesday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountWednesday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountWednesday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeWednesday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeWednesday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeWednesday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Wednesday -->

      <!-- Start Thursday -->
      <h4>{{t('thursday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("thursdayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="thursdayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('thursdayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("thursdayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="thursdayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('thursdayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("thursdayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="thursdayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('thursdayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("thursdayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="thursdayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('thursdayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountThursday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountThursday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountThursday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeThursday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeThursday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeThursday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Thursday -->

      <!-- Start Friday -->
      <h4>{{t('friday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("fridayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="fridayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('fridayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("fridayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="fridayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('fridayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("fridayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="fridayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('fridayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("fridayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="fridayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('fridayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountFriday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountFriday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountFriday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeFriday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeFriday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeFriday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Friday -->

      <!-- Start Saturday -->
      <h4>{{t('saturday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("saturdayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="saturdayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('saturdayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("saturdayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="saturdayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('saturdayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("saturdayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="saturdayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('saturdayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("saturdayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="saturdayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('saturdayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountSaturday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountSaturday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountSaturday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeSaturday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeSaturday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeSaturday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Saturday -->

      <!-- Start Sunday -->
      <h4>{{t('sunday')}}</h4>
      <kendo-formfield>
          <kendo-label>{{ t("sundayMorningFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="sundayMorningFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('sundayMorningFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("sundayMorningTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="sundayMorningTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('sundayMorningTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("sundayAfternoonFrom") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="sundayAfternoonFrom"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('sundayAfternoonFrom').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("sundayAfternoonTo") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="sundayAfternoonTo"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('sundayAfternoonTo').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("workHourAmountSunday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="workHourAmountSunday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('workHourAmountSunday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
          <kendo-label>{{ t("preliminaryWorktimeSunday") }}</kendo-label>
          <kendo-maskedtextbox
              formControlName="preliminaryWorktimeSunday"
              [mask]="editMask"
              [includeLiterals]="formGroup.get('preliminaryWorktimeSunday').value"
              [rules]="maskRules"
          >
          </kendo-maskedtextbox>
          <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      <!-- End Sunday -->

      <button
        class="mts"
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
        type="submit"
        (click)="handleUpdatePopUp()"
        loadingIndication="/workTime/updateworkTime"
        [disabled]="formGroup.invalid"
      >
        {{ t("save") }}
      </button>

      <button
          *ngIf="formGroup.get('id').value"
          class="mts"
          kendoButton
          fillMode="solid"
          size="medium"
          rounded="medium"
          themeColor="warning"
          loadingIndication="/workTime/deleteworkTime"
          (click)="showDeleteModal = true"
      >
        {{ t("delete") }}
      </button>
    </div>
    </form>

    <!-- Delete Confirmation Pop-Up -->
    <kendo-window
        [title]="t('workTimes.deleteConfirmationTitle')"
        *ngIf="showDeleteModal"
        (close)="showDeleteModal = null"
        [minWidth]="250"
        [width]="450"
        [top]="100"
        [left]="50"

    >

    <kendo-window-titlebar>
      <h2>{{t('workTimes.deleteConfirmationTitle')}}</h2>
      <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <p class="mts">{{t('workTimes.deleteConfirmationMessage')}}</p>
    <p class="error mts mbs"><strong>{{t('workTimes.deleteConfirmationWarning')}}</strong></p>

    <!-- NEW: confirmation input -->
    <label class="d-block mbm mts">
        {{ t('workTimes.typeDeleteToConfirm')}}
        <input
        kendoTextBox
        [(ngModel)]="confirmText"
        placeholder="Löschen"
        autocomplete="off"
        />
    </label>

    <button
      kendoButton
      class="mrm mtm"
      (click)="showDeleteModal = null">
      {{t('cancelButton')}}
    </button>
    <button
      kendoButton
      class="error"
      [themeColor]="'error'"
      class="mtm"
      [disabled]="confirmText?.trim() !== 'Löschen'"
      (click)="onDelete()">
      {{t('deleteButton')}}
    </button>
  </kendo-window>

  <!-- Update Confirmation Pop-Up -->
    <kendo-window
        [title]="t('workTimes.updateConfirmationTitle')"
        *ngIf="showUpdateModal"
        (close)="showUpdateModal = null"
        [minWidth]="250"
        [width]="450"
        [top]="100"
        [left]="50"
    >

    <kendo-window-titlebar>
      <h2>{{t('workTimes.updateConfirmationTitle')}}</h2>
      <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <p class="mts">{{t('workTimes.updateConfirmationMessage')}}</p>
    <p class="error mts mbs"><strong>{{t('workTimes.updateConfirmationWarning')}}</strong></p>

    <!-- NEW: confirmation input -->
    <label class="d-block mbm mts">
        {{ t('workTimes.typeUpdateToConfirm')}}
        <input
        kendoTextBox
        [(ngModel)]="confirmText"
        placeholder="Speichern"
        autocomplete="off"
        />
    </label>

    <button
      kendoButton
      class="mrm mtm"
      (click)="showUpdateModal = null">
      {{t('cancelButton')}}
    </button>
    <button
      kendoButton
      class="error"
      [themeColor]="'error'"
      class="mtm"
      [disabled]="confirmText?.trim() !== 'Speichern'"
      (click)="onSubmit()">
      {{t('save')}}
    </button>
  </kendo-window>

  </ng-container>
</ng-container>